const COMMUNITY_CLIENT_ID = "5e1e224ae4124b8d355a8148";

export const isCommunityClient = client => {
  return !!client && client._id === COMMUNITY_CLIENT_ID;
};
